import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import { Card, Col, Row, Skeleton, Statistic, Tooltip } from 'antd';
import { LanguageContext } from 'contexts/LanguageContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

function MessageCount({ system }) {
  const { userLanguage } = useContext(LanguageContext);
  const groupSeparator = userLanguage === 'br' ? '.' : ',';

  return (
    <Card
      title={
        <>
          <FormattedMessage id="message_count" />{' '}
          <Tooltip title={<FormattedMessage id="warning_message_count" />}>
            <WarningOutlined style={{ fontSize: '1.2rem', color: '#dddd00' }} />
          </Tooltip>
        </>
      }
      style={{ width: 'auto', margin: 5 }}
    >
      <Skeleton loading={system.loadingMessageCount}>
        <Row justify="space-around">
          <Col span={8}>
            <Statistic
              title={<FormattedMessage id="message_out" />}
              prefix={<ArrowUpOutlined />}
              groupSeparator={groupSeparator}
              value={system.message_count_out}
            />
            <Statistic
              title={<FormattedMessage id="message_in" />}
              prefix={<ArrowDownOutlined />}
              groupSeparator={groupSeparator}
              value={system.message_count_in}
            />
          </Col>
          <Col span={12} style={{ float: 'right' }}>
            <Statistic
              title={<FormattedMessage id="message_total" />}
              groupSeparator={groupSeparator}
              valueStyle={{ fontSize: 45 }}
              value={system.message_count_total}
            />
          </Col>
        </Row>
      </Skeleton>
    </Card>
  );
}

export default SystemConsumer(MessageCount);
